// extracted by mini-css-extract-plugin
export default {"selector":"FareSelector_selector__xt4QY"};